import { render } from "./ChatTranscript.vue?vue&type=template&id=33d154b9&scoped=true&ts=true"
import script from "./ChatTranscript.vue?vue&type=script&lang=ts"
export * from "./ChatTranscript.vue?vue&type=script&lang=ts"

import "./ChatTranscript.vue?vue&type=style&index=0&id=33d154b9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d154b9"]])

export default __exports__